import React from "react";
import { Modal, Checkbox, Row, Col, Button } from "antd";
import styles from "./ColumnSettingModal.module.scss";
import { useTranslation } from "react-i18next";

const ColumnSettingModal = ({
  open,
  columns,
  visibleCols,
  setVisibleCols,
  onClose
}) => {
  const { t: translation } = useTranslation();
  // Đảm bảo luôn có ít nhất 1 cột
  const handleCheck = (checked, key) => {
    if (checked) {
      setVisibleCols([...visibleCols, key]);
    } else if (visibleCols.length > 1) {
      setVisibleCols(visibleCols.filter(k => k !== key));
    }
  };

  return (
    <Modal
      open={open}
      title={translation("dataTable.columnSetting")}
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          {translation("dataTable.close")}
        </Button>
      ]}
      className={styles.columnSettingModal}
      centered
      maskClosable
    >
      <div className={styles.columnListWrap}>
        <Row gutter={[0, 8]}>
          {columns.map(col => {
            const key = col.dataIndex || col.key;
            const isChecked = visibleCols.includes(key);
            const isOnlyOneChecked = isChecked && visibleCols.length === 1;
            return (
              <Col span={24} key={key}>
                <Checkbox
                  checked={isChecked}
                  disabled={isOnlyOneChecked}
                  onChange={e => handleCheck(e.target.checked, key)}
                  className={styles.checkbox}
                >
                  {col.title}
                </Checkbox>
              </Col>
            );
          })}
        </Row>
      </div>
    </Modal>
  );
};

export default ColumnSettingModal;